module.exports = __webpack_public_path__ + "static/media/29EUNOG5.4319f190.jpg";